var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMuxLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 532 180",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{opacity:0.7;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M265.73,137.31A40.38,40.38,0,0,0,306.13,97V25.86a18.25,18.25,0,0,1,36.5,0V96.39a77,77,0,0,1-76.73,77h-.22a18,18,0,0,1,.05-36.06Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M265.7,137.31A40.38,40.38,0,0,1,225.3,97V25.86a18.25,18.25,0,0,0-36.5,0V96.39a77,77,0,0,0,76.73,77h.22a18,18,0,0,0-.05-36.06Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M324.38,7.63a18.23,18.23,0,1,0,18.25,18.23A18.24,18.24,0,0,0,324.38,7.63Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M363.92,38.62a18.24,18.24,0,0,1,25.81-25.78L520.8,142.37A18.23,18.23,0,0,1,495,168.14Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M520.8,38.62A18.24,18.24,0,1,0,495,12.84L363.92,142.37a18.24,18.24,0,0,0,25.81,25.77Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M507.9,137a18.23,18.23,0,1,0,18.25,18.23A18.24,18.24,0,0,0,507.9,137Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M76.65,103.88a18.24,18.24,0,1,0,25.8-25.78l-65-64.86A18.24,18.24,0,0,0,11.61,39Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M172.82,154.87a18.25,18.25,0,0,1-36.49,0V26.13a18.25,18.25,0,0,1,36.49,0Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M167.51,13.24a18.26,18.26,0,0,0-25.81,0l-65,64.86a18.24,18.24,0,1,0,25.8,25.78l65-64.86A18.21,18.21,0,0,0,167.51,13.24Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.39,7.9A18.24,18.24,0,0,0,6.15,26.13V154.87a18.25,18.25,0,0,0,36.49,0V26.13A18.24,18.24,0,0,0,24.39,7.9Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 154.58,
    cy: 154.87,
    rx: 18.25,
    ry: 18.23
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuxLogo);
export default __webpack_public_path__ + "static/media/MuxLogo.0e626819279ef5149f43f8c21d621fb0.svg";
export { ForwardRef as ReactComponent };